<template>
  <res-dialog :showDialog="showDialog"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              :title="dialogTitle"
              :titleClass="'resBlue darken-1 white--text'"
              :showTitleIcon="true"
              :titleIconSize="17"
              :iconColor="'white'"
              :saveButtonText="archiveButtonText"
              :saveDisabled="false"
              :cancelButtonText="'CANCEL'"
              :cancelButtonWidth="'80'"
              :defaultButtonAction="confirmArchive"
              @save="confirmArchive"
              @cancel="confirmCancel" >
    <v-card-text>
      <span class="font-weight-500">
         {{message}}
      </span>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      templateTitle: {
        type: String
      },
      restoreMode: {
        type: Boolean
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
    },
    methods: {
      confirmCancel() {
        this.$emit('cancelArchive', true)
      },
      confirmArchive() {
        this.$emit('confirmArchive', true)
      }
    },
    computed: {
      dialogTitle() {
        return this.restoreMode == true ? 'Un-archive Template?' : 'Archive Template?';
      },
      message() {
        return this.restoreMode == true ? 
          `Are you sure you want to un-archive the '${this.templateTitle}' template?` :
          `Are you sure you want to archive the '${this.templateTitle}' template?`;
      },
      archiveButtonText() {
        return this.restoreMode == true ? 'YES, UN-ARCHIVE' : 'YES, ARCHIVE';
      }
    }
  }
</script>

